import {
  SET_USER,
  SET_USER_TOKEN,
  SET_USER_LOADING,
  SET_USER_ERROR,
  CHANGE_LICENSE_MODAL,
} from '../constants/user';

const defaultState = {
  token: null,
  licenseModal: false,
};

export default function(state = defaultState, action) {
  const { payload, type } = action;
  switch (type) {
    case SET_USER:
      return Object.assign({}, state, payload.user);
    case SET_USER_TOKEN:
      return Object.assign({}, state, { token: payload.token });
    case SET_USER_LOADING:
      return Object.assign({}, state, { loading: payload.loading });
    case SET_USER_ERROR:
      return Object.assign({}, state, { error: payload.error });
    case CHANGE_LICENSE_MODAL:
      return Object.assign({}, state, { licenseModal: payload.mode });
    default:
      return state;
  }
}
